import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { MarkdownWithLinks } from './MarkdownWithLinks'

interface Props {
  fullNameInput?: any
  formik: any
}

const APIAccessRequestForm : React.FC<Props> = ({formik, fullNameInput}) => {

  const intl = useIntl()

  return <>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="full_name"
          {...formik.getFieldProps('full_name')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.full_name && formik.errors.full_name},
            {
              'is-valid': formik.touched.full_name && !formik.errors.full_name,
            }
          )}
          type='text'
          name='full_name'
          ref={fullNameInput}
        />
        <label className='form-label fs-6 text-gray-600'>{intl.formatMessage({id: `api_access_request.full_name`})}</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="email"
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='text'
          name='email'
        />
        <label className='form-label fs-6 text-gray-600'>{intl.formatMessage({id: `api_access_request.email`})}</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="organization"
          {...formik.getFieldProps('organization')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.organization && formik.errors.organization},
            {
              'is-valid': formik.touched.organization && !formik.errors.organization,
            }
          )}
          type='text'
          name='organization'
        />
        <label className='form-label fs-6 text-gray-600'>{intl.formatMessage({id: `api_access_request.organization`})}</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <textarea 
          placeholder="use_case"
          {...formik.getFieldProps('use_case')}
          className={clsx(
            'form-control bg-transparent h-100px border border-gray-400',
            {'is-invalid': formik.touched.use_case && formik.errors.use_case},
            {
              'is-valid': formik.touched.use_case && !formik.errors.use_case,
            }
          )}
          type='text'
          name='use_case'
        >
        </textarea>
        <label className='form-label fs-6 text-gray-600'>{intl.formatMessage({id: `api_access_request.use_case`})}</label>
      </div>
      <div className='fv-row mb-5'>
        <div className="form-check">
          <input 
            className="form-check-input" 
            type="checkbox" 
            checked={formik.values.terms_agreed}
            onChange={(e) =>
              formik.setFieldValue("terms_agreed", e.target.checked)
            }
            onBlur={formik.handleBlur}
            id="terms_agreed"
          />
          <label className="form-check-label" htmlFor="terms_agreed">
           <MarkdownWithLinks className="mb-n3">{intl.formatMessage({id: `api_access_request.agree_terms`})}</MarkdownWithLinks>
          </label>
        </div>
      </div>
    </>
}

export {APIAccessRequestForm}